export default __webpack_public_path__ + "static/Remove-Background-e3782dc24bb44f11a2cad14925b8d380.mp4";